import React, { useState } from "react";
import logo from "../../../assets/logo.png";
import "./Login.css"; 

export default function Register({ onBackToLogin }) {
  const [documento, setDocumento] = useState("");
  const [nombres, setNombres] = useState("");
  const [cargo, setCargo] = useState("");
  const [centroTrabajo, setCentroTrabajo] = useState("Sede Principal");
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  
  // ESTADO DEL CÓDIGO DE BODEGA
  const [codigoBodega, setCodigoBodega] = useState("");
  
  const [encontrado, setEncontrado] = useState(false);
  const [yaRegistrado, setYaRegistrado] = useState(false);
  const [mensaje, setMensaje] = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(false);

  // Paso 1: Buscar en la base de datos
  const handleBuscarDocumento = async () => {
    if (!documento) {
      setMensaje({ text: "Ingresa un número de documento.", type: "error" });
      return;
    }

    setMensaje({ text: "", type: "" });
    setLoading(true);
    setYaRegistrado(false);
    setCodigoBodega(""); // Limpiamos por si busca otro documento

    try {
      // 1. Buscamos los datos del empleado
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/empleados/${documento}`);
      const data = await response.json();

      if (data.success && data.empleado) {
        if (data.empleado.registrado || data.empleado.password) {
          setYaRegistrado(true);
          setEncontrado(false);
          setMensaje({ text: "Este usuario ya está registrado en el sistema.", type: "warning" });
          return;
        }

        setNombres(data.empleado.terc_nom || data.empleado.nombres || "");
        setCargo(data.empleado.empl_cargo || data.empleado.cargo || "");
        
        const areaNombre = data.empleado.area_nombre || data.empleado.centroTrabajo || "";
        setCentroTrabajo(areaNombre);
        
        if (data.empleado.terc_email || data.empleado.correo) {
          setCorreo(data.empleado.terc_email || data.empleado.correo);
        }

        // 2. BUSCAMOS AUTOMÁTICAMENTE EL CÓDIGO DE BODEGA EN LA TABLA SEDES
        try {
          const sedesRes = await fetch(`${process.env.REACT_APP_API_URL}/api/sedes`);
          const sedesData = await sedesRes.json();
          
          if (sedesData.success && sedesData.sedes) {
            // Cruzamos el nombre exacto de la sede (ej: "CENTRO DE ACOPIO")
            const sedeEncontrada = sedesData.sedes.find(
              s => s.nombre.trim().toUpperCase() === areaNombre.trim().toUpperCase()
            );
            
            if (sedeEncontrada) {
              setCodigoBodega(sedeEncontrada.codigo_bodega);
            } else {
              setCodigoBodega("No Asignado");
            }
          }
        } catch (err) {
          console.error("Error al cargar sedes:", err);
          setCodigoBodega("Error");
        }
        
        setEncontrado(true);
        setMensaje({ text: "¡Colaborador encontrado!", type: "success" });
      } else {
        setEncontrado(false);
        setMensaje({ text: data.message || "Documento no registrado.", type: "error" });
      }
    } catch (error) {
      console.error("Error al buscar:", error);
      setMensaje({ text: "Error de conexión con el servidor.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  // Paso 2: Registrar usuario
  const handleRegister = async (e) => {
    e.preventDefault();
    if (!encontrado) { handleBuscarDocumento(); return; }
    if (yaRegistrado) return;

    if (codigoBodega === "No Asignado" || codigoBodega === "Error") {
      setMensaje({ text: "No se puede registrar sin un código de bodega válido. Contacta a soporte.", type: "error" });
      return;
    }

    setMensaje({ text: "", type: "" });
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/registro`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          documento,
          nombres,
          apellidos: "",
          correo: correo.trim().toLowerCase(),
          password,
          codigo_bodega: codigoBodega 
        })
      });

      const data = await response.json();

      if (data.success) {
        setMensaje({ text: data.message || "Registro exitoso.", type: "success" });
        setTimeout(() => {
          if (onBackToLogin) onBackToLogin();
        }, 2000);
      } else {
        setMensaje({ text: data.message, type: "error" });
      }
    } catch (error) {
      console.error("Error al registrar:", error);
      setMensaje({ text: "Error de conexión.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const getAlertStyles = (type) => {
    switch (type) {
      case "success": return "bg-green-50/90 border-green-200 text-green-800";
      case "warning": return "bg-amber-50/90 border-amber-200 text-amber-800";
      case "error": default: return "bg-red-50/90 border-red-200 text-red-800";
    }
  };

  return (
    <div className="login-container">
      <div className="login-card !px-6 !py-6 !max-w-[400px]"> 
        <div className="flex justify-center mb-3 w-full">
          <img src={logo} alt="Logo" className="h-12 w-auto object-contain drop-shadow-md" />
        </div>

        <div className="text-center mb-4 w-full">
          <h2 className="text-xl sm:text-2xl font-extrabold text-gray-900 tracking-tight">Registro</h2>
          <p className="text-xs text-gray-800 font-medium mt-0.5">Verifica tu documento para unirte</p>
        </div>

        {mensaje.text && (
          <div className={`mb-4 w-full px-3 py-2 rounded-xl text-xs font-medium text-center border backdrop-blur-md shadow-sm animate-fade-in-up ${getAlertStyles(mensaje.type)}`}>
            {mensaje.text}
          </div>
        )}

        <form onSubmit={handleRegister} className="w-full space-y-3">
          
          <div>
            <label className="block text-[10px] font-bold text-gray-900 uppercase tracking-wide mb-1 pl-1">
              N° de Documento
            </label>
            <div className="flex gap-2">
              <input 
                type="text" 
                placeholder="Ej. 1002345678" 
                value={documento} 
                onChange={(e) => setDocumento(e.target.value)} 
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !encontrado) {
                    e.preventDefault();
                    handleBuscarDocumento();
                  }
                }}
                required
                className="w-full px-4 py-2.5 bg-white/60 border border-white/70 rounded-xl text-gray-900 placeholder-gray-500 font-medium text-sm focus:bg-white/90 focus:border-[#007aff] focus:ring-2 focus:ring-[#007aff]/20 transition-all outline-none shadow-sm"
              />
              <button 
                type="button"
                onClick={handleBuscarDocumento}
                disabled={loading}
                className="px-4 py-2.5 bg-gray-900 hover:bg-gray-800 text-white font-bold text-sm rounded-xl shadow-md transition-all active:scale-[0.98]"
              >
                {loading && !encontrado ? "..." : "Buscar"}
              </button>
            </div>
          </div>

          {yaRegistrado && (
            <div className="pt-2 animate-fade-in-up">
              <button 
                type="button" 
                onClick={onBackToLogin}
                className="w-full py-3 bg-[#007aff] hover:bg-[#0062cc] text-white font-bold text-sm rounded-full shadow-md transition-all active:scale-[0.98]"
              >
                Ir a Iniciar Sesión
              </button>
            </div>
          )}

          {encontrado && !yaRegistrado && (
            <div className="animate-fade-in-up space-y-3">
              
              <div>
                <label className="block text-[10px] font-bold text-gray-900 uppercase tracking-wide mb-1 pl-1">
                  Nombre Completo
                </label>
                <input 
                  type="text" 
                  value={nombres} 
                  readOnly 
                  className="w-full px-4 py-2 bg-white/30 border border-white/40 rounded-xl text-gray-700 text-sm font-medium cursor-not-allowed outline-none shadow-sm"
                />
              </div>

              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className="block text-[10px] font-bold text-gray-900 uppercase tracking-wide mb-1 pl-1">
                    Cargo
                  </label>
                  <input 
                    type="text" 
                    value={cargo} 
                    readOnly 
                    className="w-full px-3 py-2 bg-white/30 border border-white/40 rounded-xl text-gray-700 text-xs font-medium cursor-not-allowed outline-none shadow-sm"
                  />
                </div>
                <div>
                  <label className="block text-[10px] font-bold text-gray-900 uppercase tracking-wide mb-1 pl-1 truncate">
                    Centro Trab.
                  </label>
                  <input 
                    type="text" 
                    value={centroTrabajo} 
                    readOnly
                    className="w-full px-3 py-2 bg-white/30 border border-white/40 rounded-xl text-gray-700 text-xs font-medium cursor-not-allowed outline-none shadow-sm"
                  />
                </div>
              </div>

              <div>
                <label className="block text-[10px] font-bold text-gray-900 uppercase tracking-wide mb-1 pl-1">
                  Correo Electrónico
                </label>
                <input 
                  type="email" 
                  placeholder="@correo.com" 
                  value={correo} 
                  onChange={(e) => setCorreo(e.target.value)} 
                  required
                  className="w-full px-3 py-2.5 bg-white/60 border border-white/70 rounded-xl text-gray-900 placeholder-gray-500 font-medium text-xs focus:bg-white/90 focus:border-[#007aff] focus:ring-2 focus:ring-[#007aff]/20 transition-all outline-none shadow-sm"
                />
              </div>

              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label className="block text-[10px] font-bold text-gray-900 uppercase tracking-wide mb-1 pl-1 text-blue-800">
                    Cód. Bodega
                  </label>
                  <input 
                    type="text" 
                    value={codigoBodega} 
                    readOnly
                    className="w-full px-3 py-2.5 bg-white/30 border border-white/40 rounded-xl text-gray-700 font-bold text-xs cursor-not-allowed outline-none shadow-sm text-center"
                  />
                </div>
                <div>
                  <label className="block text-[10px] font-bold text-gray-900 uppercase tracking-wide mb-1 pl-1">
                    Contraseña <span className="text-red-500">*</span>
                  </label>
                  <input 
                    type="password" 
                    placeholder="••••••••" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    required
                    className="w-full px-3 py-2.5 bg-white/60 border border-white/70 rounded-xl text-gray-900 placeholder-gray-500 font-medium text-xs focus:bg-white/90 focus:border-[#007aff] focus:ring-2 focus:ring-[#007aff]/20 transition-all outline-none shadow-sm"
                  />
                </div>
              </div>

              <div className="pt-2">
                <button 
                  type="submit" 
                  disabled={loading || codigoBodega === "No Asignado" || codigoBodega === "Error"}
                  className={`w-full py-3 text-white font-extrabold text-sm rounded-full transition-all flex justify-center items-center ${
                    (loading || codigoBodega === "No Asignado" || codigoBodega === "Error")
                      ? "bg-blue-400 cursor-not-allowed" 
                      : "bg-[#007aff] hover:bg-[#0062cc] shadow-md hover:-translate-y-0.5 active:scale-[0.98]"
                  }`}
                >
                  {loading ? "Guardando..." : "Completar Registro"}
                </button>
              </div>
            </div>
          )}
        </form>

        <div className="mt-4 text-center w-full">
          <button 
            type="button"
            onClick={onBackToLogin}
            className="text-xs font-bold text-[#005bb5] hover:text-[#003d82] transition-colors hover:underline"
          >
            ¿Ya tienes cuenta? Inicia sesión
          </button>
        </div>
      </div>
    </div>
  );
}